import React from 'react';
import { InfoRowGroupItem } from '@model/content';
import { InfoRow } from './InfoRow';

export interface InfoRowGroupProps {
  items: Array<InfoRowGroupItem>;
}

export const InfoRowGroup = ({ items }: InfoRowGroupProps) => {
  return (
    <>
      {items.map((props: InfoRowGroupItem) => (
        <InfoRow key={props.title} openInNewTab={props.newWindow} {...props} />
      ))}
    </>
  );
};
